module.exports = __webpack_public_path__ + "static/media/doctor-conversation.5b4898fb.png";